
export default class Parallax {

	constructor(){

		this.el = {
			parallax: document.querySelectorAll('[data-parallax]')
		};

		this.parallaxElements = [];
		this.scrollTop = window.pageYOffset;
		this.targetScroll = this.scrollTop;
		this.scrollEase = 0.1;

		this.isEnabled = this.el.parallax.length > 0;

		this.tick = this.tick.bind(this);
		this.tick();

		this._domReady();
	}

	//

	_domReady(){

		for (let i = 0; i < this.el.parallax.length; i++) {

			this.parallaxElements.push({
				el: this.el.parallax[i],
				speed: (Math.random() - 0.5) * 0.2,
				offset: () => {
					return this.el.parallax[i].getBoundingClientRect().top
				}
			});
		}
	}

	//

	tick(){

		if( !this.isEnabled ){
			return;
		}

		this.targetScroll = window.pageYOffset;
		this.scrollTop = this.scrollTop + (this.targetScroll - this.scrollTop) * this.scrollEase;

		for( let i = 0; i < this.parallaxElements.length; i++ ){
			const y = (this.scrollTop - this.parallaxElements[ i ].offset()) * this.parallaxElements[ i ].speed;
			this.parallaxElements[ i ].el.style.transform = `translateZ(0) translateY(${ -y }px)`;
		}

		requestAnimationFrame(this.tick);
	}
}
